import { render, staticRenderFns } from "./LayoutRight.vue?vue&type=template&id=010e7038"
import script from "./LayoutRight.vue?vue&type=script&lang=js"
export * from "./LayoutRight.vue?vue&type=script&lang=js"
import style0 from "./LayoutRight.vue?vue&type=style&index=0&id=010e7038&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports